var _a;
import { configureStore } from "@reduxjs/toolkit";
import manageTripsDashboardHeaderReducer from "./slices/manage-trips/dashboard-header-slice";
import { uiReducer } from "./slices";
import { userReducer } from "./slices/user-slice";
import { categoriesReducer } from "./slices/categories-slice";
export var RootKeysEnum;
(function (RootKeysEnum) {
    RootKeysEnum["ui"] = "ui";
    RootKeysEnum["user"] = "user";
    RootKeysEnum["auth"] = "auth";
    RootKeysEnum["trips"] = "trips";
    RootKeysEnum["manageTripsDashboardHeader"] = "manageTripsDashboardHeader";
    RootKeysEnum["categories"] = "categories";
})(RootKeysEnum || (RootKeysEnum = {}));
export var store = configureStore({
    reducer: (_a = {},
        _a[RootKeysEnum.ui] = uiReducer,
        _a[RootKeysEnum.user] = userReducer,
        _a[RootKeysEnum.manageTripsDashboardHeader] = manageTripsDashboardHeaderReducer,
        _a[RootKeysEnum.categories] = categoriesReducer,
        _a),
});
